import React from 'react'
import MissionVision from '../home/MissionVision'
import Opportunities from '../home/Opportunities'

const DirectorMessage = () => {
  return (
    <>
      {/* <section className="choose-us-section pb-0 section-bg fix bg-cover" style={{ backgroundImage: 'url(assets/img/choose-us/bg-1.png)' }}>
        <div className="container">
          <div className="choose-us-wrapper">
            <div className="row g-4 align-items-center">
              <div className="col-lg-6">
                <div className="choose-us-content">
                  <div className="section-title">
                    <span className="sub-title wow fadeInUp">Director's Message</span>
                    <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                      Mr. Jagrat Kapoor
                    </h2>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                      The main objective of the school is to enhance children’s capacity for critical thinking and creative expression by using innovative methods of learning and teaching. Buddha in his last sermon to his disciple exhorted that enlightenment cannot be taught and only you can do that miracle to yourself. Thus was born the idea of Aatma Deepo Bhava, which means ‘Be a light unto yourself’ – And this is our school motto.
                    </p>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                      At Saraswati Vidyapeeth, students get learning opportunities over and above conventional academic pursuits. By engaging with the four stakeholders of education, children, community, educators and school, we want to foster a learning environment that enables students to develop holistically.
                    </p>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                      The world of education demands constant reforms and upgradation to engage and inspire young minds. Today’s children are already exposed to a plethora of information via technology at a very early age and hence are more explorative.
                    </p>
                  </div>
                 
                </div>
              </div>
              <div className="col-lg-6">
                <div className="choose-us-image">
                  <img src="assets/img/svp/gallery/45.jpg" alt="img" style={{borderRadius:"10px"}} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                  
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="choose-us-section pb-0 section-bg fix bg-cover" style={{ backgroundImage: 'url(assets/img/choose-us/bg-1.png)' }}>
        <div className="container">
          <div className="choose-us-wrapper">
            <div className="row g-4 align-items-center">
              <div className="col-lg-6">
                <div className="choose-us-content">
                  <div className="section-title">
                    <span className="sub-title wow fadeInUp">Director's Message</span>
                    <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                      Mr. Jagrat Kapoor
                    </h2>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s" style={{ textAlign: "justify" }}>
                      At Saraswati Vidhyapeeth Satna, we are driven by a strong vision to nurture future-ready, confident, and disciplined individuals. Our ultimate goal is to upgrade our institution into a full-fledged Sainik School, and this transformative journey may begin at any time. We are fully committed and prepared to meet the standards of such an institution in both infrastructure and values.
                    </p>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s" style={{ textAlign: "justify" }}>
                      Currently, we proudly operate as a dual-medium, CBSE-partnered school, offering both English and Hindi mediums to cater to a diverse range of students. Our emphasis is not limited to academics alone we focus on the holistic development of every child.
                    </p>
                    <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s" style={{ textAlign: "justify" }}>
                      We offer a robust ecosystem for sports, athletics, yoga, and even shooting, ensuring that students develop physical strength, discipline, and leadership qualities from an early age. In addition, we provide specialized coaching for competitive examinations such as NEET, JEE, and NDA, aligning our curriculum to help students achieve success in every sphere of life.
                      With a disciplined environment, dedicated faculty, and state-of-the-art facilities, Saraswati Vidhyapeeth is preparing students not just for exams, but for life.
                    </p>

                  </div>
                  <div className="choose-us-item" style={{ marginTop: "-30px" }}>
                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".7s
                          ">
                      {/* <div className="icon">
                        <i className="flaticon-teacher" />
                      </div> */}
                      <div className="content">
                        <p>Warm regards,</p>
                        <h3>Mr. Jagrat Kapoor</h3>
                        <p>
                          Secretary , Saraswati Vidhyapeeth, Satna
                        </p>
                      </div>
                    </div>
                    {/* <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s
                          ">
                      <div className="icon">
                        <i className="flaticon-skills" />
                      </div>
                      <div className="content">
                        <h3>Skill Based Scholarships</h3>
                        <p>
                          Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia for
                          this deserunt.
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="choose-us-image">
                  <img src="assets/img/svp/gallery/45.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                  {/* <div className="circle-shape">
                    <img src="assets/img/choose-us/circle-shape.png" alt="img" className="wow img-custom-anim-top" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                  </div> */}
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    </>
  )
}

export default DirectorMessage